// Parst den EPC-QR-Code ("Girocode") gemaess EPC069-12-Spezifikation. Reiner
// mehrzeiliger Text, Felder durch Zeilenumbruch getrennt:
// 1 "BCD" (Service-Tag) | 2 Version | 3 Zeichensatz | 4 "SCT" | 5 BIC (optional)
// | 6 Name | 7 IBAN | 8 Betrag ("EUR12.30") | 9 Verwendungszweck-Code (optional)
// | 10 Strukturierte Referenz (optional) | 11 Verwendungszweck-Freitext (optional)
// | 12 Info fuer Auftraggeber (optional)
export function parseGirocode(text) {
	const lines = text.split(/\r\n|\r|\n/);
	if ((lines[0] || '').trim() !== 'BCD') {
		throw new Error('Das ist kein gültiger Girocode.');
	}

	const bic = (lines[4] || '').trim();
	const name = (lines[5] || '').trim();
	const iban = (lines[6] || '').replace(/\s/g, '').trim();
	const amountField = (lines[7] || '').trim();
	const structuredRef = (lines[9] || '').trim();
	const purposeText = (lines[10] || '').trim();

	if (iban === '') {
		throw new Error('Girocode enthält keine IBAN.');
	}

	let amount = '';
	const amountMatch = amountField.match(/^EUR(\d+(?:[.,]\d{1,2})?)$/i);
	if (amountMatch) {
		amount = amountMatch[1].replace(',', '.');
	}

	return {
		recipientName: name,
		recipientIban: iban,
		recipientBic: bic,
		amount: amount,
		purpose: purposeText || structuredRef || '',
	};
}
